module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "id": "attach",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = !_vm.menu
      }
    }
  }, [_c('v-icon', [_vm._v("playlist_play")])], 1), _vm._v(" "), _c('v-menu', {
    ref: "menu",
    attrs: {
      "attach": "#attach",
      "absolute": "",
      "top": "",
      "left": "",
      "close-on-content-click": false,
      "close-on-click": false,
      "max-height": "600",
      "max-width": _vm.$vuetify.breakpoint.smAndUp ? 480 : 300,
      "min-width": _vm.$vuetify.breakpoint.smAndUp ? 480 : 290
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-card', {
    staticClass: "fill-height"
  }, [(_vm.player.playlist) ? _c('v-list', {
    attrs: {
      "id": "next-up",
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "title"
  }, [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_vm._v("Next Up")]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "d-flex mr-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "depressed": ""
    },
    on: {
      "click": _vm.clearPlaylist
    }
  }, [_vm._v("\n                            Clear\n                        ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1)])], 1), _vm._v(" "), _c('draggable', {
    attrs: {
      "options": _vm.draggableOptions
    },
    on: {
      "start": _vm.onDragStart,
      "end": _vm.onDragEnd
    },
    model: {
      value: (_vm.playlist),
      callback: function($$v) {
        _vm.playlist = $$v
      },
      expression: "playlist"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.player.playlist), function(audio, i) {
    return _c('v-list-tile', {
      key: i,
      staticClass: "hover-show-hidden",
      class: {
        'no-hover-opacity': i < _vm.player.position
      }
    }, [_c('v-list-tile-action', {
      staticClass: "px-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.player.position === i) ? _c('v-progress-circular', {
      attrs: {
        "rotate": 270,
        "size": 22,
        "width": 3,
        "value": _vm.player.duration && (_vm.player.time / _vm.player.duration) * 100,
        "color": "primary"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("play_arrow")])], 1) : _c('div', {
      staticClass: "handle hidden"
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("drag_indicator")])], 1)], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('v-list-tile-action', {
      staticClass: "mr-1",
      on: {
        "click": function($event) {
          _vm.$store.dispatch('setPosition', i)
        }
      }
    }, [_c('div', {
      staticClass: "cover-container"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": audio.imgSource,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "hidden play-pause"
    }, [(_vm.player.position === i && _vm.player.state === 1) ? _c('v-btn', {
      staticClass: "no-transition",
      attrs: {
        "small": "",
        "icon": "",
        "dark": "",
        "ripple": false,
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.$store.dispatch('setState', 2)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("pause")])], 1) : _c('v-btn', {
      staticClass: "no-transition",
      attrs: {
        "small": "",
        "icon": "",
        "dark": "",
        "ripple": false,
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.$store.dispatch('setPosition', i) && _vm.$store.dispatch('setState', 1)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("play_arrow")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "v-list__tile__content",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "to": {
          name: 'Track',
          params: {
            id: audio.id
          }
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "semi-bold"
    }, [_vm._v("\n                                        " + _vm._s(audio.name) + "\n                                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                        " + _vm._s(audio.artist) + "\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.player.position !== i),
        expression: "player.position !== i"
      }],
      staticClass: "hidden no-transition",
      attrs: {
        "icon": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(i)
        }
      }
    }, [_c('v-icon', {
      staticClass: "no-transition"
    }, [_vm._v("delete")])], 1)], 1)], 1)
  }))], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4d74b00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/ThePlayerCurrentPlaylist.vue
// module id = 400
// module chunks = 0